import { render, staticRenderFns } from "./StatisticsAnalysisCard.vue?vue&type=template&id=047876a4&scoped=true&"
import script from "./StatisticsAnalysisCard.vue?vue&type=script&lang=js&"
export * from "./StatisticsAnalysisCard.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsAnalysisCard.vue?vue&type=style&index=0&id=047876a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047876a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDivider,VIcon,VListItem,VListItemContent,VRow})
